export enum MarketplaceItemStockType {
  SingleStockType = 0,
  AttributeStockType = 1
}
